import merge from 'lodash/merge';
import {ALLOW_NEW_REQUEST, LAST_PAGE, NEXT_PAGE, RESET_LAZY_LOADER, SET_LAST_KEY} from "../actions/lazyload";
import {SET_ACTIVE_CATEGORY_INDEX} from "../actions/api";


const DEFAULT_STATE = {
  currentPage: -1,
  totalPages: 0,
  lastPage: false,
  justMadeReq: false,
  lastKey: null
};

const lazyLoadReducer = (state = DEFAULT_STATE, action) => {
  Object.freeze(state)
  let newState = merge({}, state);

  switch (action.type) {
    case NEXT_PAGE:
      newState.currentPage += 1;
      newState.justMadeReq = true;
      return newState;
    case ALLOW_NEW_REQUEST:
      newState.justMadeReq = false;
      return newState;
    case SET_LAST_KEY:
      newState.lastKey = action.lastKey;
      return newState;
    case RESET_LAZY_LOADER:
    case SET_ACTIVE_CATEGORY_INDEX:
      newState = DEFAULT_STATE;
      return newState;
    case LAST_PAGE:
      newState.lastPage = action.isLastPage;
      return newState;
    default:
      return state;
  }

};

export default lazyLoadReducer;


// WEBPACK FOOTER //
// ./src/reducers/lazyLoadReducer.js